@if (hasSocial) {
    <div class="agpr-madSocial">
        <!-- Cards -->
        <div class="agpr-madSocial-cards">
            <div class="agpr-madSocial-cards-card">
                <agpr-card-chart
                    [series]="totalVolumeCardSeries"
                    [color]="cardChartComponentHighlightColors.volume"
                    [bubbleTooltipMetric]="socialMetrics.VOLUME"
                    [headingLevel]="4"
                ></agpr-card-chart>
            </div>
            <div class="agpr-madSocial-cards-card">
                <agpr-card-chart
                    [series]="totalImpressionCardSeries"
                    [color]="cardChartComponentHighlightColors.impressions"
                    [bubbleTooltipMetric]="socialMetrics.IMPRESSIONS"
                    [headingLevel]="4"
                ></agpr-card-chart>
            </div>
            <div class="agpr-madSocial-cards-card">
                <agpr-card-chart
                    [series]="totalEngagementCardSeries"
                    [color]="cardChartComponentHighlightColors.engagements"
                    [bubbleTooltipMetric]="socialMetrics.ENGAGEMENTS"
                    [headingLevel]="4"
                ></agpr-card-chart>
            </div>
        </div>

        <!-- Summary By Social Network -->
        <div
        class="agpr-madSocial-summaryTrend agpr-contextMenu-parent"
        #summaryBySocialNetworkChartElement>
            <div class="agpr-madSocial-exportMenu agpr-contextMenu top right">
                <agpr-chart-export-menu
                    id="summaryBySocialNetworkChart_export"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                    (exportMenuClicked)="exportChart($event, summaryBySocialNetworkChartElement, madSocialChartTypeEnum.COVERAGE_OVER_TIME)"
                    [contextMenu]="true"
                    [social]="true"
                ></agpr-chart-export-menu>
            </div>
            <label class="agpr-madSocial-summaryTrend-header">{{ 'Monitor.MAD.social.summaryTrend' | localize }}</label>
            <div class="agpr-madSocial-summaryTrend-socials">
                <agpr-network-radio
                    [availableNetworks]="availableNetworkTypes"
                    [defaultSelection]="currentSocialType"
                    (selectedNetwork)="setSocialTypes($event)"
                    [ariaLabel]="'Social.intelligence.themeAnalytics.engagement.socialNetworksLabel'"
                    [id]="id + '_networkTypes'"
                ></agpr-network-radio>
            </div>
            <div class="agpr-madSocial-summaryTrend-charts">
                <div class="agpr-madSocial-summaryTrend-left">
                    <agpr-card-chart
                        class="agpr-madSocial-card--column"
                        [series]="summaryTotalVolumeCardSeries"
                        [color]="cardChartComponentHighlightColors.volume"
                        [layout]="cardChartLayoutTypes.vertical"
                        [bubbleTooltipMetric]="socialMetrics.VOLUME"
                        [headingLevel]="4"
                    ></agpr-card-chart>
                    <agpr-card-chart
                        class="agpr-madSocial-card--column"
                        [series]="summaryTotalImpressionCardSeries"
                        [color]="cardChartComponentHighlightColors.impressions"
                        [layout]="cardChartLayoutTypes.vertical"
                        [bubbleTooltipMetric]="socialMetrics.IMPRESSIONS"
                        [headingLevel]="4"
                    ></agpr-card-chart>
                    <agpr-card-chart
                        class="agpr-madSocial-card--column"
                        [series]="summaryTotalEngagementCardSeries"
                        [color]="cardChartComponentHighlightColors.engagements"
                        [layout]="cardChartLayoutTypes.vertical"
                        [bubbleTooltipMetric]="socialMetrics.ENGAGEMENTS"
                        [headingLevel]="4"
                    ></agpr-card-chart>
                </div>
                <div class="agpr-madSocial-summaryTrend-right">
                    <div class="agpr-mad-chartAnchor {{ summaryTrendLineChartClass }}">
                        <agpr-am5-chart
                            [ngClass]="{ 'agpr-madSocial-chart--noData': summaryTrendLineChartNoData }"
                            [chart]="summaryTrendLineChart"
                            [series]="summaryTrendLineSeries"
                            (noContent)="updateSummaryTrendLineChartNoData($event)"
                            (tooltipLinkClick)="openAm5ChartDrilldown($event)"
                        ></agpr-am5-chart>
                    </div>
                </div>
            </div>
        </div>


        <!-- Social Network Comparison -->
        @if (shareOfVoiceBySocialNetwork) {
            <div
                class="agpr-madSocial-chartContainer agpr-contextMenu-parent"
                #shareOfVoiceBySocialNetworkChartElement
            >
                <div class="agpr-madSocial-exportMenu agpr-contextMenu top right">
                    <agpr-chart-export-menu
                        id="shareOfVoiceBySocialNetwork_export"
                        iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                        [supportedFormats]="supportedExportFormats"
                        (exportMenuClicked)="exportChart($event, shareOfVoiceBySocialNetworkChartElement, madSocialChartTypeEnum.SOCIAL_COVERAGE_BY_NETWORK)"
                        [contextMenu]="true"
                        [social]="true"
                    ></agpr-chart-export-menu>
                </div>
                <div class="agpr-mad-chartAnchor {{ shareOfVoiceBySocialNetworkClass }}">
                    <agpr-chart-group
                        [charts]="shareOfVoiceBySocialNetwork"
                        [showLoadingUntil]="chartLoadingOptionsEnum.none"
                        [id]="id"
                    ></agpr-chart-group>
                </div>
            </div>
        }

        <!-- Social Sentiment Trend -->
        @if (sentimentTrendChart) {
            <div
                class="agpr-madSocial-chartContainer agpr-madSocial-chartContainer-noBottomPadding agpr-contextMenu-parent"
                #sentimentTrendChartElement
            >
                <div class="agpr-madSocial-exportMenu agpr-contextMenu top right">
                    <agpr-chart-export-menu
                        id="sentimentTrendChart_export"
                        iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                        [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                        (exportMenuClicked)="exportChart($event, sentimentTrendChartElement, madSocialChartTypeEnum.SENTIMENT_TREND)"
                        [contextMenu]="true"
                        [social]="true"
                    ></agpr-chart-export-menu>
                </div>
                <div class="agpr-madSocial-summaryTrend-header-container">
                    <label class="agpr-madSocial-summaryTrend-header">{{ 'Monitor.MAD.social.sentimentTrend' | localize }}</label>
                    <agpr-tabs
                        [(selectedTabIndex)]="selectedSentimentTrendChartTabIndex"
                        (selectedTabIndexChange)="sentimentTrendChartStackTypeChanged($event)"
                    >
                        <agpr-tab
                            [id]="'madSocial_sentimentTrendChart_percentage'"
                            [heading]="'Monitor.MAD.social.sentimentTrend.' + stackTypes.percent"
                        ></agpr-tab>
                        <agpr-tab
                            [id]="'madSocial_sentimentTrendChart_volume'"
                            [heading]="'Monitor.MAD.social.sentimentTrend.' + stackTypes.count"
                        ></agpr-tab>
                    </agpr-tabs>
                </div>
                <div class="agpr-mad-chartAnchor {{ sentimentTrendChartClass }}">
                    <agpr-am5-chart
                        [ngClass]="{ 'agpr-madSocial-chart--noData': sentimentTrendChartNoData }"
                        [chart]="sentimentTrendChart"
                        [series]="sentimentTrendSeries"
                        (noContent)="updateSentimentTrendChartNoData($event)"
                        (tooltipLinkClick)="openAm5ChartDrilldown($event)"
                    ></agpr-am5-chart>
                </div>
            </div>
        }

        <!-- Top Terms -->
        <div class="agpr-madSocial-topTerms">
            <agpr-top-terms
                #topTermChart
                [id]="'themeAnalytics.topterms.mostUsed'"
                [series]="mostUsedTopTermsSeries"
                [initialMetric]="mentionSearchFacetTypesEnum.hashtags"
                [config]="mostUsedTopTermsConfig"
                [availableNetworkTypes]="availableNetworkTypes"
                [useNeoFacets]="(isAccountSearch || isSavedCoverage) ? false : true"
                [forceSocialMediaTypes]="true"
            ></agpr-top-terms>
        </div>

        <!-- Top posts -->
        <div class="agpr-madSocial-topPosts">
            <agpr-top-posts
                #topPostsChart
                [id]="'summaryTopPosts'"
                [availableNetworkTypes]="availableNetworkTypes"
                [series]="topPostsSeries"
                [sortIndex]="1"
            >
            </agpr-top-posts>
        </div>
    </div>
} @else {
    <div class="agpr-madSocial-upsellMessage">
        <span class="agpr-madSocial-upsellMessage-icon fa-kit-duotone fa-agpr-social"></span>
        <div class="agpr-madSocial-upsellMessage-text">
            <span>{{ 'Monitor.MAD.social.upsell.message1' | localize }}</span><span class="agpr-madSocial-upsellMessage-text--bold">{{ 'Monitor.MAD.social.upsell.message2' | localize }}</span>
        </div>
        <agpr-button
            [id]="'agpr_madSocial_upsellMessage_button'"
            label="Monitor.MAD.social.upsell.buttonText"
            [style]="buttonTypes.primary"
            (click)="openUpsellDialog()"
        ></agpr-button>
    </div>
}
